import React from 'react';

import WpProgressBar from 'Wpds/components/progress/WpProgressBar';

import { SyncMeetingsSteps } from '../../types';

type Props = {
  steps: Array<SyncMeetingsSteps>;
  currentStep: SyncMeetingsSteps;
};

function StepsSection({ steps, currentStep }: Props) {
  const numSteps = steps.length;
  const currentStepIndex = steps.indexOf(currentStep) + 1;

  return <WpProgressBar percent={(currentStepIndex / numSteps) * 100} />;
}

export default StepsSection;
